import React, { useState, useEffect, useRef } from 'react';

export function LicenseDropdown({ selected, options, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggle = (lic) => {
        const current = selected || [];
        if (current.includes(lic)) {
            onChange(current.filter(l => l !== lic));
        } else {
            onChange([...current, lic]);
        }
    };

    return (
        <div className="employee-license-selector" ref={dropdownRef}>
            <div className={`license-selector-trigger ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                <span className="license-selector-value">
                    {(!selected || selected.length === 0) ? 'Führerschein wählen...' : 
                     selected.join(', ')}
                </span>
                <span style={{ fontSize: '10px', opacity: 0.5 }}>{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <div className="license-selector-dropdown">
                    {options.map(lic => (
                        <div key={lic}
                            className={`license-option ${selected?.includes(lic) ? 'selected' : ''}`}
                            onClick={() => toggle(lic)}>
                            {lic}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
